import { useQuery } from 'react-query';
import request from '../../helpers/request';
import { withCancelToken } from '../helpers/withCancelToken';

const endPoint =
  'Acceptance/acceptance_get_current_stage_and_step_address_life_cycle';

const createKey = ({ addressId }) => {
  return [endPoint, addressId];
};

const fetcher = ({ params, source }) => {
  return request.get(
    endPoint,
    params,
    undefined,
    'Error',
    undefined,
    undefined,
    { cancelToken: source.token },
    true
  );
};

const cancelableFetcher = (params) => {
  return withCancelToken((source) => fetcher({ params, source }));
};

const useRoomLifeCycleStateQuery = ({
  params: { addressId } = {},
  options,
}) => {
  return useQuery(
    createKey({ addressId }),
    () => cancelableFetcher({ addressId }),
    {
      enabled: Boolean(addressId),
      ...options,
    }
  );
};

export { useRoomLifeCycleStateQuery };
